<script lang="ts">
const __DsBlock = {
	type: 'container',
	icon: 'carbon:condition-point',
	description: '$t:blocks.condition.description',
	category: 'basic',
	hidden: true,
	slots: ['true', 'false'],
	options: [
		{
			name: 'operator',
			type: 'enum',
			values: ['=', '>', '<', '>=', '<=', 'match regex', 'empty', 'contain'],
		},
	],
}
</script>
<script lang="ts" setup>
import { computed, ref } from 'vue';
import { defineBlock, useBlockInEditor } from '#layers/block-engine/public';

const props = defineProps<{
	a: any;
	operator: '=' | '>' | '<' | '>=' | '<=' | 'match regex' | 'empty' | 'contain';
	b: any;
	not?: boolean;
}>();

;

const baseCondition = computed(() => {
	// Type Casting
	let a = props.a;
	let b = props.b;

	// Boolean
	if (typeof a === 'boolean' && String(b) !== 'true') {
		a = a.toString();
	}

	if (typeof b === 'boolean') {
		b = b.toString();
	}

	// Date
	if (a instanceof Date) {
		a = a.getTime();
	}

	if (b instanceof Date) {
		b = b.getTime();
	}

	// Operation
	switch (props.operator) {
		case '=': {
			if (String(b) === 'true') {
				return !!a;
			}

			// eslint-disable-next-line eqeqeq
			return a == b;
		}

		case '>': return a > b;
		case '<': return a < b;
		case '>=': return a >= b;
		case '<=': return a <= b;

		case 'match regex': {
			const result = b.match(/^\/(.*)\/([gimuy]*)$/);

			const regex = result ? new RegExp(result[1], result[2]) : new RegExp(b);

			return regex.test(a);
		}

		case 'empty': return a == null || a.length === 0;

		case 'contain': {
			if (typeof a === 'string') {
				return a.includes(b);
			}

			if (Array.isArray(a)) {
				return a.includes(b);
			}

			return false;
		}

		default: return false;
	}
});

const condition = computed(() => {
	const value = baseCondition.value;

	if (props.not) {
		return !value;
	}

	return value;
});

const inEditor = useBlockInEditor();
const forceCondition = ref(true);
</script>

<template>
	<BlockInteractiveZone v-if="inEditor">
		<DButton
			size="xs"
			color="neutral"
			variant="soft"
			icon="carbon:condition-point"
			:trailing-icon="forceCondition ? 'lucide:toggle-right' : 'lucide:toggle-left'"
			block
			class="m-1 w-[stretch] cursor-pointer"
			@click="forceCondition = !forceCondition"
		>
			{{ $t('blocks.condition.editor_toggle') }} (<span class="text-bold font-mono text-sm text-primary">{{ forceCondition }}</span>)
		</DButton>
	</BlockInteractiveZone>

	<slot
		v-if="inEditor ? forceCondition : condition"
		name="true"
	/>
	<slot
		v-else
		name="false"
	/>
</template>
